import {
  Component,
  OnInit,
  Input,
  OnDestroy,
  Output,
  EventEmitter
} from "@angular/core";
import { Subject } from "rxjs";
import { MultiSelectPipe } from "@app/shared/pipes/multi-select.pipe";
import * as _ from "lodash";

@Component({
  selector: "app-multi-select-custom",
  templateUrl: "./multi-select-custom.component.html",
  styleUrls: ["./multi-select-custom.component.css"]
})
export class MultiSelectCustomComponent implements OnInit, OnDestroy {
  @Input()
  set listItems(list) {
    this.completeList = list;
    this.suggestions = list;
  }
  @Input()
  set placeholderText(value) {
    this.placeholder = value;
  }
  @Input()
  set groupedBy(value) { }
  @Input()
  set countryRegionMappingList(list) {
    this.countryRegionMappingListItems = list;
  }
  @Output() selectionEvent = new EventEmitter<Array<String>>();
  suggestions: any = [];
  completeList: any = [];
  placeholder: string = "Choose";
  searchTerm$ = new Subject<string>();
  userSelectsString = "";
  userSelects = [];
  show: boolean = false;
  countryRegionMappingListItems = [];
  selectedRegions = [];
  result: any = {
    data: [],
    isAllRegionSelected: false
  };

  regions: number;
  countries: number;
  selectedItems = [];

  constructor(private multiSelectPipe: MultiSelectPipe) { }
  ngOnDestroy(): void {
    this.searchTerm$.unsubscribe();
  }

  ngOnInit(): void {
    this.searchTerm$.subscribe(resp => {
      if (resp) {
        this.suggestions = this.multiSelectPipe.transform(
          this.completeList,
          resp
        );
      } else {
        this.suggestions = this.completeList;
      }
    });
  }

  suggest() {
    this.show = true;
    this.suggestions = this.multiSelectPipe.transform(this.completeList, "");
  }

  isSelected(data: any) {
    return this.userSelects.findIndex(item => item.id === data.id) > -1
      ? true
      : false;
  }
  isDisabled(data: any) {
    //get region
    const item = this.countryRegionMappingListItems.find(
      item => item.id === data.id
    );
    if (item && item.geographies[0]) {
      if (
        this.userSelects.findIndex(x => x.id === item.geographies[0].id) > -1
      ) {
        return true;
      } else {
        return false;
      }
    } else {
      return false;
    }
  }

  selectSuggestion(data) {
    if (data.category === "Region") {
      this.countryMapping(data);
    } else {
      let itemIndex = this.userSelects.find(item => item.id === data.id);
      this.userSelects.find(item => item.id === data.id)
        ? (this.userSelects = this.userSelects.filter(
          item => item.id !== data.id
        ))
        : this.userSelects.push(data);
    }
  }

  deleteSelects(s) {
    this.userSelects = this.userSelects.filter(item => item.id !== s.id);
  }

  assignToNgModel() {
    this.userSelectsString = "";
    this.userSelects.map(item => (this.userSelectsString += item.name + " "));
  }
  selectAll(event, items) {
    for (let i = 0; i < items.value.length; i++) {
      const findIndex = this.userSelects.findIndex(
        item => item.id === items.value[i].id
      );
      const countryList = this.countryRegionMappingListItems.filter(data => {
        if (data.geographies[0] && data.geographies[0].geographicTitle) {
          return (
            data.geographies[0].geographicTitle === items.value[i].itemName
          );
        } else {
          // handle invalid data
        }
      });
      if (event.target.checked) {
        if (findIndex === -1) {
          this.userSelects.push(items.value[i]);
          if (items.key !== "Country") {
            this.result.isAllRegionSelected = true;
            this.userSelects = _.uniqWith(
              [...this.userSelects, ...countryList],
              _.isEqual
            );
          }
        }
      } else {
        this.result.isAllRegionSelected = false;
        if (findIndex !== -1 && items.key === "Country") {
          const mappedList = this.countryRegionMappingListItems.find(
            data => items.value[i].id === data.id
          );
          const findMapIndex = this.userSelects.findIndex(seletionItem => {
            return (
              mappedList.geographies &&
              mappedList.geographies[0] &&
              seletionItem.id === mappedList.geographies[0].id
            );
          });
          if (findMapIndex === -1) {
            this.userSelects.splice(findIndex, 1);
          }
        } else if (findIndex !== -1) {
          this.userSelects.splice(findIndex, 1);
          for (let selected = 0; selected < countryList.length; selected++) {
            this.userSelects = this.userSelects.filter(
              item => item.id !== countryList[selected].id
            );
          }
        }
      }
    }
  }
  isAllchecked(item) {
    let cateLength;
    if (item.key === "Country") {
      cateLength = this.userSelects.filter(x => {
        if (x.category === item.key) {
          return true;
        } else if (x.countryCode && x.countryCode != "") {
          return true;
        } else {
          return false;
        }
      });
    } else {
      cateLength = this.userSelects.filter(x => x.category === item.key);
    }
    if (cateLength.length == item.value.length) {
      return true;
    } else {
      return false;
    }
  }
  closeComponent() {
    let regionsList = [];
    let countryList = [];
    const filteredCountryList = [];
    regionsList = this.userSelects.filter(data => data.category === 'Region');
    countryList = this.userSelects.filter(data => data.category === 'Country' || data.countryCode !== undefined);
    if (regionsList.length > 0) {
    countryList.find(country => {
      const relation = this.countryRegionMappingListItems.find(data => data.id === country.id);
      const isExistRegion = regionsList.findIndex(region => region.id === relation.geographies[0].id);
      if (isExistRegion !== -1) {
        return false;
      } else {
        filteredCountryList.push(country);
      }
    });
    this.result.data = [...regionsList, ...filteredCountryList];
  } else {
    this.result.data = [...regionsList, ...countryList];
  }
    this.selectedItems = _.map(this.result.data, 'itemName');
    this.selectionEvent.emit(this.result);
  }

  countryMapping(item) {
    let selectedIndex;
    let isChecked;
    if (item.category === "Region") {
      selectedIndex = this.userSelects.findIndex(data => data.id === item.id);
      if (selectedIndex > -1) {
        this.userSelects.splice(selectedIndex, 1);
        isChecked = false;
      } else {
        isChecked = true;
        this.userSelects.push(item);
      }
      const countryList = this.countryRegionMappingListItems.filter(data => {
        if (data.geographies[0] && data.geographies[0].geographicTitle) {
          return data.geographies[0].geographicTitle === item.itemName;
        } else {
          //invalid data 
        }
      });
      for (let k = 0; k < countryList.length; k++) {
        const findIndex = this.userSelects.findIndex(
          item => item.id === countryList[k].id
        );
        if (findIndex === -1) {
          this.userSelects.push(countryList[k]);
        } else if (findIndex !== -1 && !isChecked) {
          this.userSelects.splice(findIndex, 1);
        }
      }
    }
  }

  getCount() {
    this.regions = 0;
    this.countries = 0;

    this.userSelects.forEach( (data) => {
      if (data.category) {
        this.regions += 1;
      } else {
        this.countries += 1;
      }
    });
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/components/multi-select-custom/multi-select-custom.component.ts